"use client";

import { OptimizedImage } from "@/components/ui/optimized-image";

interface MobileImageCarouselProps {
  images: string[];
  productName: string;
}

/**
 * 가로 스크롤 이미지 캐러셀 (캐치테이블 스타일)
 * - 모든 이미지 148x148px 고정
 * - gap 1px, 첫/끝만 라운드
 * - 좌우 px-4 여백
 */
export default function MobileImageCarousel({
  images,
  productName,
}: MobileImageCarouselProps) {
  const displayImages = images.slice(0, 10);

  if (displayImages.length === 0) {
    return (
      <div className="px-4">
        <div className="w-[148px] h-[148px] rounded-xl bg-gray-100 flex items-center justify-center">
          <span className="text-gray-400 text-sm">No image</span>
        </div>
      </div>
    );
  }

  const lastIdx = displayImages.length - 1;

  return (
    <div className="flex overflow-x-auto scrollbar-hide">
      {/* 왼쪽 spacer */}
      <div className="shrink-0 w-4" />
      {displayImages.map((img, i) => (
        <div
          key={i}
          className={`shrink-0 w-[148px] h-[148px] overflow-hidden relative ${
            i > 0 ? "ml-px" : ""
          } ${
            i === 0 && i === lastIdx
              ? "rounded-xl"
              : i === 0
                ? "rounded-l-xl"
                : i === lastIdx
                  ? "rounded-r-xl"
                  : ""
          }`}
        >
          <OptimizedImage
            src={img}
            alt={displayImages.length === 1 ? productName : `${productName} ${i + 1}`}
            fill
            sizes="148px"
            className="object-cover"
            loading={i === 0 ? "eager" : "lazy"}
          />
        </div>
      ))}
      {/* 오른쪽 spacer */}
      <div className="shrink-0 w-4" />
    </div>
  );
}
